// Shared date validation utilities for appointment booking
// These functions ensure consistent weekend validation across all appointment creation modules

/**
 * Check if a date falls on a weekend (Saturday or Sunday)
 * @param {Date} date - The date to check
 * @returns {boolean} - True if the date is Saturday or Sunday, false otherwise
 */
export const isWeekend = (date) => {
  const dayOfWeek = date.getDay();
  return dayOfWeek === 0 || dayOfWeek === 6; // 0 = Sunday, 6 = Saturday
};

/**
 * Get the next business day (Monday-Friday)
 * If the date is Saturday or Sunday, returns the following Monday
 * @param {Date} date - The date to check
 * @returns {Date} - The next business day (or the same date if it's already a weekday)
 */
export const getNextBusinessDay = (date) => {
  const dayOfWeek = date.getDay();
  const result = new Date(date);
  
  if (dayOfWeek === 6) { // Saturday
    result.setDate(result.getDate() + 2); // Skip to Monday
  } else if (dayOfWeek === 0) { // Sunday
    result.setDate(result.getDate() + 1); // Skip to Monday
  }
  
  return result;
};
